import { useState } from 'react'
import { LuLock, LuX, LuLoader } from 'react-icons/lu'
import './PasswordModal.css'

function PasswordModal({ isOpen, onClose, onConfirm, title, message, loading }) {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  if (!isOpen) return null

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    
    if (!password) {
      setError('Ingrese su contraseña')
      return
    }

    const result = await onConfirm(password)
    
    if (!result.success) {
      setError(result.error || 'Contraseña incorrecta')
      setPassword('')
    }
  }

  const handleClose = () => {
    setPassword('')
    setError('')
    onClose()
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3><LuLock /> {title || 'Confirmar Operación'}</h3>
          <button className="modal-close" onClick={handleClose} disabled={loading}>
            <LuX />
          </button>
        </div>
        
        <div className="modal-body">
          <p className="modal-message">
            {message || 'Por seguridad, ingrese su contraseña para confirmar esta operación.'}
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Contraseña</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingrese su contraseña"
                className="form-control"
                autoFocus
                disabled={loading}
              />
            </div>
            
            {error && <div className="modal-error">{error}</div>}
            
            <div className="modal-actions">
              <button 
                type="button" 
                onClick={handleClose}
                className="btn-secondary"
                disabled={loading}
              >
                Cancelar
              </button>
              <button 
                type="submit"
                className="btn-primary"
                disabled={loading}
              >
                {loading ? <><LuLoader className="spinner-icon" /> Verificando...</> : 'Confirmar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default PasswordModal

